import { useState } from "react";
import "./App.css";
import { GeoQuizApp } from "./app/GeoQuizApp";
import { MenuScreen, MapSelection } from "./app/MenuScreen";
import { ModeScreen } from "./app/ModeScreen";
import { MathMenu, MathSettings } from "./app/MathMenu";
import { MathQuizApp } from "./app/MathQuizApp";
import { MathModeScreen } from "./app/MathModeScreen";
import { ShapesGame } from "./app/ShapesGame";
import { MazeGame } from "./app/MazeGame";

function App() {
  const [screen, setScreen] = useState<
    | "mode"
    | "geo-menu"
    | "geo-quiz"
    | "math-hub"
    | "math-menu"
    | "math-quiz"
    | "math-shapes"
    | "math-maze"
  >("mode");
  const [mapSelection, setMapSelection] = useState<MapSelection>("poland");
  const [mathSettings, setMathSettings] = useState<MathSettings | null>(null);

  return (
    <div className="App">
      {screen === "mode" && (
        <ModeScreen
          onSelectGeography={() => setScreen("geo-menu")}
          onSelectMath={() => setScreen("math-hub")}
        />
      )}
      {screen === "geo-menu" && (
        <MenuScreen
          onSelect={(selection) => {
            setMapSelection(selection);
            setScreen("geo-quiz");
          }}
          onBack={() => setScreen("mode")}
        />
      )}
      {screen === "geo-quiz" && (
        <GeoQuizApp
          mapSelection={mapSelection}
          onBack={() => setScreen("geo-menu")}
        />
      )}
      {screen === "math-hub" && (
        <MathModeScreen
          onBack={() => setScreen("mode")}
          onSelectComputations={() => setScreen("math-menu")}
          onSelectShapes={() => setScreen("math-shapes")}
          onSelectMaze={() => setScreen("math-maze")}
        />
      )}
      {screen === "math-menu" && (
        <MathMenu
          onBack={() => setScreen("math-hub")}
          onStart={(settings) => {
            setMathSettings(settings);
            setScreen("math-quiz");
          }}
        />
      )}
      {screen === "math-quiz" && mathSettings && (
        <MathQuizApp
          settings={mathSettings}
          onBack={() => setScreen("math-menu")}
        />
      )}
      {screen === "math-shapes" && (
        <ShapesGame onBack={() => setScreen("math-hub")} />
      )}
      {screen === "math-maze" && (
        <MazeGame onBack={() => setScreen("math-hub")} />
      )}
    </div>
  );
}

export default App;
